export default __webpack_public_path__ + "static/goods-campaign-3-2306bd766e6fc7b872cd315eb07edfa9.png";